import {Record} from 'immutable';

export default Record({
  id: null,
  name: null,
  cardsNumber: null,
});
